import { render, staticRenderFns } from "./UnavailablePage.vue?vue&type=template&id=130162a7&scoped=true&"
import script from "./UnavailablePage.vue?vue&type=script&lang=js&"
export * from "./UnavailablePage.vue?vue&type=script&lang=js&"
import style0 from "./UnavailablePage.vue?vue&type=style&index=0&id=130162a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130162a7",
  null
  
)

export default component.exports